export enum RTCEvent {
    Dispatch = 'dispatch',
    Subscribe = 'subscribe',
    NewEvent = 'newEvent',
    SubscriptionConfirmation = 'subscriptionConfirmation',
    GameShowLaunched = 'gameShowLaunched',
    GameShowUpdated = 'gameShowUpdated',
    StudentRejected = 'studentRejected',
    StudentAnswered = 'studentAnswered',
    StudentSolution = 'studentSolution',
    StudentJoined = 'studentJoined',
    StudentLeft = 'studentLeft',
    DeleteStudentSolution = 'deleteStudentSolution',
    QuestionClosed = 'questionClosed',
    QuestionChoicesReceived = 'questionChoicesReceived',
    FeedbackReceived = 'feedbackReceived',
    Connect = 'connect',
    Disconnect = 'disconnect'
}
